import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/animation_bike.gif';
import _imports_1 from '../assets/home-page-text.png';
var _hoisted_1 = { class: "home" };
var _hoisted_2 = { class: "home-container" };
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("header", { class: "home-images" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "bike-logo",
        src: _imports_0,
        alt: "腳踏車圖"
    }),
    /*#__PURE__*/ _createElementVNode("img", {
        class: "text-image",
        src: _imports_1,
        alt: "where's your bike"
    }),
    /*#__PURE__*/ _createElementVNode("h2", { class: "title" }, "微    笑    單    車．暢    遊    城    市")
], -1);
var _hoisted_4 = { class: "button-group" };
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("尋找 Youbike");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("查詢自行車道");
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("附近景點、美食");
var _hoisted_8 = /*#__PURE__*/ _createElementVNode("footer", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Where’s YouBike © Code: 文科少女 / Design: KT")
], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_el_button = _resolveComponent("el-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("body", _hoisted_4, [
                _createVNode(_component_el_button, {
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.redirecTo('FindBike')); })
                }, {
                    default: _withCtx(function () { return [
                        _hoisted_5
                    ]; }),
                    _: 1
                }),
                _createVNode(_component_el_button, {
                    onClick: _cache[1] || (_cache[1] = function ($event) { return (_ctx.redirecTo('FindBikeLane')); })
                }, {
                    default: _withCtx(function () { return [
                        _hoisted_6
                    ]; }),
                    _: 1
                }),
                _createVNode(_component_el_button, {
                    onClick: _cache[2] || (_cache[2] = function ($event) { return (_ctx.redirecTo('FindScenicFood')); })
                }, {
                    default: _withCtx(function () { return [
                        _hoisted_7
                    ]; }),
                    _: 1
                })
            ]),
            _hoisted_8
        ])
    ]));
}
